export default __webpack_public_path__ + "static/media/cherryswash-regular-webfont.51598638.ttf";